<template>
	<v-card>
		<!-- Total amounts -->
		<v-layout row wrap>
			<v-flex xs12 sm10 offset-sm1 md6 offset-md3 lg4 offset-lg4>
				<!-- Expandable -->
				<v-expansion-panels>
				<v-expansion-panel>

				<v-list dense>
					<v-list-item>
						<v-list-item-content>{{ txt.totalNetto }} :</v-list-item-content>
						<v-list-item-content class="align-end">
								<!-- ES-lint IS CAUSING AN ERROR . THIS IS CORRECT:
								totalSums("sum_row_total_excl_tax"),
								currencyFormatLocal.locale,
								currencyFormatLocal.currency | toCurrency
								-->
							{{
								totalSums("sum_row_total_excl_tax"),
								currencyFormat.locale,
								currencyFormat.currency | toCurrency
							}}
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>{{ txt.tax }} :</v-list-item-content>
						<v-list-item-content class="align-end">{{
							// eslint-disable-next-line vue/no-parsing-error
							totalSums("sum_tax_amount"),
								currencyFormat.locale,
								currencyFormat.currency | toCurrency
						}}
						</v-list-item-content>
					</v-list-item>
					<strong>
						<v-list-item>
						<v-list-item-content>
							{{ txt.grossExclPayments }} :</v-list-item-content
						>
						<v-list-item-content class="align-end">{{
							totalSums("sum_row_total_excl_discount"), currencyFormat.locale, currencyFormat.currency | toCurrency
							}}
						</v-list-item-content>
					</v-list-item>
					</strong>
					<v-list-item>
						<v-list-item-content>{{ txt.onSitePurchaseGross }} :</v-list-item-content>
						<v-list-item-content class="align-end">{{
							totalSums("sum_price_incl_tax", onSitePurchasesSums),
								currencyFormat.locale,
								currencyFormat.currency | toCurrency
						}}
						</v-list-item-content>
					</v-list-item>
					<strong>
						<v-list-item>
						<v-list-item-content>
							{{ txt.grandTotal }} :</v-list-item-content
						>
						<v-list-item-content class="align-end">{{
							grandTotal(), currencyFormat.locale, currencyFormat.currency | toCurrency
							}}
						</v-list-item-content>
					</v-list-item>
					</strong>
				</v-list>
				<v-expansion-panel-header> Detail info
				<v-expansion-panel-content class="expansionFluid">
				<v-list>
					<v-divider></v-divider>
					<v-list-item>
						<v-list-item-content> {{ txt.units }} :</v-list-item-content>
						<v-list-item-content class="align-end">{{
							totalSums("sum_quantity")
						}}</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>{{ txt.onSitePurchaseQuantity }} :</v-list-item-content>
						<v-list-item-content class="align-end">{{
							totalSums("sum_quantity", onSitePurchasesSums)
						}}</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content>{{ txt.discount }} :</v-list-item-content>
						<v-list-item-content class="align-end">{{
							totalSums("sum_discount_amount"),
								currencyFormat.locale,
								currencyFormat.currency | toCurrency
						}}</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>{{ txt.refund }} :</v-list-item-content>
						<v-list-item-content class="align-end">{{
							totalRefundsSums("sum_quantity", "sum_row_total_incl_tax"),
								currencyFormat.locale,
								currencyFormat.currency | toCurrency
						}}</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content
							>{{ txt.resellerComission }} :</v-list-item-content
						>
						<v-list-item-content class="align-end">{{
							totalSums("sum_reseller_comission_amount"),
								currencyFormat.locale,
								currencyFormat.currency | toCurrency
						}}</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content
							>{{ txt.serviceproviderCommissionNet }} :</v-list-item-content
						>
						<v-list-item-content class="align-end">{{
							totalSums("sum_serviceprovider_commission_net"),
								currencyFormat.locale,
								currencyFormat.currency | toCurrency
						}}</v-list-item-content>
					</v-list-item>

				</v-list>
				</v-expansion-panel-content>
				</v-expansion-panel-header>
				</v-expansion-panel>
				</v-expansion-panels>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
export default {
	props: ['revenueItems', 'sums', 'onSitePurchasesSums', 'pagination', 'currencyFormat'],
	data() {
		return {
			txt: {
				title: 'Total values',
				expandableTitle: 'Details',
				totalNetto: 'Total online revenue net',
				totalBrutto: 'Total gross',
				tax: 'Tax amount',
				units: 'Total online revenue quantity',
				discount: 'Discount given',
				resellerComission: 'Reseller commission',
				totalNettoExclResellerComission: 'Revenue net excl. reseller comission',
				grossExclPayments: 'Total online revenue gross',
				refund: 'Refund / cancellation',
				serviceproviderCommissionNet: 'Serviceprovider commission net.',
				onSitePurchaseGross: 'Total on-site revenue gross',
				onSitePurchaseQuantity: 'Total on-site revenue quantity',
				grandTotal: 'Grand total',
			},
			localSums: [],
		}
	},

	methods: {
		grandTotal() {
			return this.totalSums('sum_row_total_excl_discount') + this.totalSums('sum_price_incl_tax', this.onSitePurchasesSums)
		},
		totalSums(column, sourceArray = this.sums) {
			const sums = sourceArray || this.sums
			if (sums.length > 0) {
				const accumulated = sums.reduce((total, item) => {
					try {
						// eslint-disable-next-line no-return-assign
						return (total += parseFloat(item[column]))
					} catch (e) {
						return total
					}
				}, 0)
				if (Number.isNaN(accumulated)) return 0
				return accumulated
			}
			return 0
		},
		totalRefundsSums(quantity, column) {
			if (this.sums.length > 0) {
				const accumulated = this.sums.reduce((total, item) => {
					try {
						const multiplicator = item[quantity] > 0 ? 0 : 1
						// eslint-disable-next-line no-return-assign
						return (total += parseFloat(item[column] * multiplicator))
					} catch (e) {
						return total
					}
				}, 0)
				if (Number.isNaN(accumulated)) {
					return 0
				}
				return accumulated
			}
			return 0
		},
	},
	filters: {
		toCurrency(amount, locale, currencyLocal) {
			const number = Number(amount)
			const formatter = new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: currencyLocal,
				minimumFractionDigits: 2,
			})
			return formatter.format(number)
		},
	},
}
</script>

<style scoped>
.align-end{
	margin-right: -50%;
	padding: unset;
	/* fix for huge amounts overflowing the box */
	flex: 1 1 auto !important;
    overflow: hidden;
}
</style>
